var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { isBidEditable } from '../../hooks/useColumns';
import MaterialTable from '../MaterialTable';
import { bid as bidApi } from '../../api';
import { useRequest } from '../../hooks/requestHook';
import { useNotify } from '../../hooks/notificationHook';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var BidsTable = function (_a) {
    var bids = _a.bids, columns = _a.columns, actions = _a.actions, onUpdate = _a.onUpdate, onDelete = _a.onDelete, role = _a.role, _b = _a.isUSRoaster, isUSRoaster = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var updateBid = useRequest(bidApi.update);
    var destroyBid = useRequest(bidApi.destroy);
    var notify = useNotify();
    var handleUpdate = React.useCallback(function (bid) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onUpdate)
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, updateBid({
                            id: bid.id,
                            bid: __assign(__assign({}, (isUSRoaster
                                ? { fob_price_usd_per_lb: bid.fobPriceUsdPerLb }
                                : { fob_price: bid.fobPrice })), { quantity: bid.quantity, buy_partial: bid.buyPartial }),
                        })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    onUpdate(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, notify, updateBid, onUpdate]);
    var handleDelete = React.useCallback(function (bid) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onDelete)
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, destroyBid({ id: bid.id })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    onDelete(response);
                    notify('success', [
                        role === 'admin'
                            ? t('messages.updateSuccess')
                            : t('messages.deleteSuccess'),
                    ]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, setLoading, notify, destroyBid, onDelete, role]);
    return (React.createElement(Wrapper, null,
        React.createElement(MaterialTable, { model: "bid", isLoading: loading, columns: columns, actions: actions, data: bids, editable: role !== 'producer'
                ? {
                    isEditable: isBidEditable,
                    onRowUpdate: onUpdate && handleUpdate,
                    isDeletable: isBidEditable,
                    onRowDelete: onDelete && handleDelete,
                    deleteTooltip: function () { return (role === 'admin' ? 'reject' : 'cancel'); },
                }
                : undefined, options: {
                sorting: false,
                paging: false,
                showSelectAllCheckbox: false,
                showTextRowsSelected: false,
            }, localization: {
                header: {
                    actions: '',
                },
                body: {
                    emptyDataSourceMessage: t('labels.noData'),
                    editRow: {
                        deleteText: role === 'admin'
                            ? t('messages.rejectConfirm')
                            : t('messages.bidCancelConfirm'),
                    },
                },
            } })));
};
export default BidsTable;
var templateObject_1;
